app.directive('rewardCreditSummary', [
  'checkoutService',
  '$compile',
  'logger',
  function (checkoutService, $compile, logger) {
    return {
      restrict: 'A',
      link: function (scope, element) {
        scope.$on('checkout.cart.summary.changed', function () {
          checkoutService
            .requestPartial('cart', 'reward_credit_summary')
            .then(function (res) {
              element.html(res.data);
            })
            .catch(function (err) {
              logger.error('Unable to load reward credit', err);
            });
        });
        scope.$on('checkout.cart.summary.reload', function () {
          checkoutService
            .requestPartial('cart', 'reward_credit_summary')
            .then(function (res) {
              element.html(res.data);
            })
            .catch(function (err) {
              logger.error('Unable to load reward credit', err);
            });
        });
      },
    };
  },
]);
